import React from 'react';
interface FormPreviewProps {
  html: string;
  css?: string;
}
export function FormPreview({
  html,
  css
}: FormPreviewProps) {
  const baseStyles = 'body { font-family: system-ui, -apple-system, sans-serif; padding: 20px; margin: 0; }';
  // Check if the HTML is a full document (has its own <html> or <!DOCTYPE>)
  const isFullDocument = /<!doctype\s+html|<html[\s>]/i.test(html);
  let htmlDoc: string;
  if (isFullDocument) {
    // GPT-generated full HTML document — inject CSS into the existing <head>
    // Remove any external stylesheet links (they won't resolve in preview)
    let cleanedHtml = html.replace(/<link[^>]*rel=["']stylesheet["'][^>]*\/?>/gi, '');
    // Build a plain <style>{`tag — NO template literal wrappers
    const cssBlock = '<style>' + baseStyles + '\n' + (css || '') + '`}</style>';
    if (/<\/head>/i.test(cleanedHtml)) {
      htmlDoc = cleanedHtml.replace(/<\/head>/i, cssBlock + '</head>');
    } else if (/<head[^>]*>/i.test(cleanedHtml)) {
      htmlDoc = cleanedHtml.replace(/<head([^>]*)>/i, '<head$1>' + cssBlock);
    } else {
      htmlDoc = '<!DOCTYPE html><html><head>' + cssBlock + '</head><body>' + cleanedHtml + '</body></html>';
    }
  } else {
    // Partial HTML (just form markup) — wrap in a full document with a plain <style>{`tag
    htmlDoc = '<!DOCTYPE html><html><head><style>' + baseStyles + '\n' + (css || '') + '`}</style></head><body>' + html + '</body></html>';
  }
  return <div className="w-full h-[500px] bg-gray-50 rounded border border-gray-200 overflow-hidden" data-id="element-831">
      <iframe srcDoc={htmlDoc} title="Form Preview" className="w-full h-full border-0" sandbox="allow-scripts" data-id="element-832" />
    </div>;
}